// Закреплённая шапка, которая прячется при прокрутке вниз и возвращается при
// прокрутке вверх. У самого верха страницы шапка всегда видна и без фона —
// за подложку отвечает класс .scrolled (градиент описан в main.scss).

// Ниже этого сдвига страница считается прокрученной: появляется подложка
const SCROLLED_OFFSET = 20;
// Прокрутка мельче этой не считается сменой направления — иначе шапка дёргается
// от инерции тачпада и субпиксельных подвижек
const DIRECTION_THRESHOLD = 5;

export default function stickyHeader(element, data) {
    // Пока шапка не уехала целиком, прятать нечего
    const hideOffset = Number(data.hideOffset) || element.offsetHeight;

    let lastScroll = Math.max(window.scrollY, 0);
    let scheduled = false;

    update();

    function update() {
        const scroll = Math.max(window.scrollY, 0);
        const delta = scroll - lastScroll;

        element.classList.toggle("scrolled", scroll > SCROLLED_OFFSET);

        if (scroll <= hideOffset) {
            element.classList.remove("hidden");
            lastScroll = scroll;
            return;
        }

        if (Math.abs(delta) < DIRECTION_THRESHOLD) {
            return;
        }

        element.classList.toggle("hidden", delta > 0);
        lastScroll = scroll;
    }

    window.addEventListener("scroll", function () {
        // Классы меняем раз в кадр, а не на каждое событие прокрутки
        if (scheduled) {
            return;
        }

        scheduled = true;
        requestAnimationFrame(function () {
            scheduled = false;
            update();
        });
    }, {
        passive: true
    });
}
